import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-[#0d0d0d] shadow-lg' : 'bg-[#0d0d0d]'
    }`}>
      <div className="max-w-[87.5rem] mx-auto px-5 md:px-10">
        <div className="flex items-center justify-between h-20">
          {/* Logo Section */}
          <div className="flex flex-col items-start gap-1">
            <img 
              src="https://customer-assets.emergentagent.com/job_gym-photography/artifacts/m7mn43sp_Fit%20Frame%20Logo.svg"
              alt="FIT-FRAME Logo"
              className="h-12 w-auto"
            />
            <p className="text-[#888680] text-[10px] font-['DM_Sans'] leading-tight">
              by Offline Capture
            </p>
          </div>

          {/* Desktop CTA */}
          <div className="hidden md:block">
            <Button 
              onClick={() => scrollToSection('pricing')}
              className="bg-[#e8ff47] text-[#0d0d0d] hover:opacity-90 rounded-full px-8 py-6 font-['DM_Sans'] font-semibold text-base uppercase tracking-tight transition-all hover:scale-105"
            >
              Book a Shoot
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-[#e8ff47] p-2"
          >
            <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2">
              {isMobileMenuOpen ? (
                <path d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path d="M3 12h18M3 6h18M3 18h18" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden pb-4">
            <Button 
              onClick={() => scrollToSection('pricing')}
              className="bg-[#e8ff47] text-[#0d0d0d] hover:opacity-90 rounded-full px-8 py-6 font-['DM_Sans'] font-semibold text-base uppercase w-full"
            >
              Book a Shoot
            </Button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
